import { render, staticRenderFns } from "./CreatePhaseStatusFormStep1.vue?vue&type=template&id=7da27ccb&scoped=true&"
import script from "./CreatePhaseStatusFormStep1.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusFormStep1.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePhaseStatusFormStep1.vue?vue&type=style&index=0&id=7da27ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da27ccb",
  null
  
)

export default component.exports